import { useContext } from 'react';

import CompletedProjectContext from './completed-project.context';

function useCompletedProject() {
  const context = useContext(CompletedProjectContext);

  if (!context) {
    throw new Error('useCompletedProject must be used within CompletedProjectProvider');
  }

  return context;
}

export default useCompletedProject;